<form #formResponsavel="ngForm">
  <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlex="18%" fxFlexOffset="20px">
        <input matInput name="dataVinculacao" [matDatepicker]="dataVinculacao" placeholder="Data de vinculação:"
              [(ngModel)]="responsavel.dataVinculacao" (input)="onMascaraDataInput($event)" required>
        <mat-datepicker-toggle matSuffix [for]="dataVinculacao"></mat-datepicker-toggle>
        <mat-datepicker #dataVinculacao></mat-datepicker>
    </mat-form-field>


    <mat-form-field fxFlex="18%">
      <input matInput name="dataDesvinculacao" [matDatepicker]="dataDesvinculacao" placeholder="Data de Desvinculação:"
            [(ngModel)]="responsavel.dataDesvinculacao" (input)="onMascaraDataInput($event)">
      <mat-datepicker-toggle matSuffix [for]="dataDesvinculacao"></mat-datepicker-toggle>
      <mat-datepicker #dataDesvinculacao></mat-datepicker>
    </mat-form-field>

  </div>

  <div fxLayout="row"  fxLayoutGap="20px" fxFlexFill>
    <div fxFlexOffset="20px" fxFlex= "30%">
      <mat-checkbox name="transportaAluno" [(ngModel)]="responsavel.transportaAluno">Autorização para levar e buscar o aluno.</mat-checkbox>
    </div>
    <div fxFlex= "30%">
      <mat-checkbox name="tutelaAluno" [(ngModel)]="responsavel.tutelaAluno">Tem a tutela do aluno.</mat-checkbox>
    </div>
    <div fxFlex= "30%">
      <mat-checkbox name="responsavelFinanceiroPeloAluno" [(ngModel)]="responsavel.responsavelFinanceiroPeloAluno">Responsável financeiro pelo aluno.</mat-checkbox>
    </div>
  </div>
  <br/>

  <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 20px; margin-bottom: 10px" fxFlexFill>
    <combo-grau-parentesco fxFlexOffset="20px" fxFlex="50%"
                           [selecionado]="familiar.grauParentesco"
                           [obrigatorio]="false"
                           (valorChange)="onGrauParentescoChange($event)">
    </combo-grau-parentesco>

    <mat-form-field  fxFlex= "50%" appearance="outline" >
      <mat-label>Descrição de desvinculação</mat-label>
      <textarea matInput #descDesligamento
                name="descDesligamento"
                [(ngModel)]="responsavel.descDesligamento"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                maxlength="200"></textarea>
      <mat-hint align="end">{{descDesligamento.value.length}} / 200</mat-hint>
    </mat-form-field>

  </div>
</form>





